/**
 * Connected Inventory Display Helper
 * Shows real-time connected inventory status on frontend
 * (Backend webhook handles actual inventory synchronization)
 */

window.ConnectedInventory = (function() {

  var skuGroups = {};
  var currentProduct = null;

  function init(productData) {
    if (!productData || !productData.variants) return;

    currentProduct = productData;
    buildSkuGroups();
    displayConnectedInfo();
  }

  function buildSkuGroups() {
    skuGroups = {};

    currentProduct.variants.forEach(function(variant) {
      if (variant.sku) {
        if (!skuGroups[variant.sku]) {
          skuGroups[variant.sku] = [];
        }
        skuGroups[variant.sku].push(variant);
      }
    });
  }

  function displayConnectedInfo() {
    // Show info about connected inventory to customers
    var connectedSkus = Object.keys(skuGroups).filter(function(sku) {
      return skuGroups[sku].length > 1;
    });

    if (connectedSkus.length > 0) {
      addConnectedInventoryInfo();
    }
  }

  function addConnectedInventoryInfo() {
    var productForm = document.querySelector('.product-form, form[action*="cart/add"]');
    if (!productForm) return;

    var infoDiv = document.createElement('div');
    infoDiv.className = 'connected-inventory-info';
    infoDiv.innerHTML = `
      <div class="inventory-notice" style="
        background: #f0f8ff;
        border: 1px solid #d4e6f1;
        border-radius: 4px;
        padding: 10px;
        margin: 10px 0;
        font-size: 13px;
        color: #2c3e50;
      ">
        <strong><i class="icon-shipped"></i> Free Shipping</strong>
        
      </div>
    `;

    productForm.insertBefore(infoDiv, productForm.firstChild);
  }

  function interceptSelectCallback(originalCallback) {
    return function(variant, selector) {
      // Let the original callback handle normal functionality
      if (originalCallback) {
        originalCallback.call(this, variant, selector);
      }

      // Add our connected inventory display logic
      displayVariantConnections(variant);
    };
  }

  function displayVariantConnections(variant) {
    if (!variant || !variant.sku) return;

    var connectedVariants = skuGroups[variant.sku] || [];

    if (connectedVariants.length > 1) {
      var connectedInfo = document.querySelector('.connected-variants-info');
      if (!connectedInfo) {
        connectedInfo = document.createElement('div');
        connectedInfo.className = 'connected-variants-info';
        connectedInfo.style.cssText = `
          font-size: 12px;
          color: #666;
          margin-top: 5px;
          font-style: italic;
        `;

        var skuElement = document.querySelector('.product-sku, .sku');
        if (skuElement && skuElement.parentNode) {
          skuElement.parentNode.insertBefore(connectedInfo, skuElement.nextSibling);
        }
      }

      var availableCount = connectedVariants.filter(function(v) {
        return v.available && v.inventory_quantity > 0;
      }).length;

      connectedInfo.innerHTML = `
        Connected with ${connectedVariants.length - 1} other variant(s)
        (${availableCount}/${connectedVariants.length} available)
      `;
    }
  }

  return {
    init: init,
    interceptSelectCallback: interceptSelectCallback,
    displayConnectedInfo: displayConnectedInfo
  };
})();